import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  IsSave: boolean = false;
  IsMobile: boolean = false;
  IsMobileDevice: boolean = false;
  ThanhVienID: number = 0;
  constructor(public snackBar: MatSnackBar) {
    if (localStorage.getItem(environment.ThanhVienID)) {
      this.ThanhVienID = Number(localStorage.getItem(environment.ThanhVienID));
    }
    let windowWidth = Math.floor(window.innerWidth);

    if (windowWidth < 700) {
      this.IsMobile = true;
    }
    // Phát hiện thiết bị di động / WebView (Cordova)
    this.IsMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || (window as any).cordova != null;
    console.log('NotificationService init - IsMobile:', this.IsMobile, 'IsMobileDevice:', this.IsMobileDevice, 'UA:', navigator.userAgent);
    this.IsSave=false;
  }

  /**
   * Chặn thao tác ghi dữ liệu trên mobile (APK) theo yêu cầu:
   * Trả về true nếu đã chặn và đã hiển thị cảnh báo.
   */
  blockMobileActionIfNeeded(): boolean {
    if (this.IsMobileDevice) {
      this.warn('Chức năng này chỉ khả dụng trên Website, vui lòng sử dụng trên web.');
      return true;
    }
    return false;
  }

  config: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
  }
  success(message: string) {
    // Trên mobile (APK/Cordova) chỉ cần alert chặn hành động,
    // không cần hiện toast "Lưu thành công" nữa để tránh gây hiểu nhầm.
    if (this.IsMobileDevice) {
      return;
    }
    this.config['panelClass'] = ['notification', 'success'];
    this.snackBar.open(message, '', this.config);
  }

  warn(message: string) {
    // Trên mobile, nếu message là "Lưu thành công" thì đổi thành "Lưu không thành công"
    if (this.IsMobileDevice && message === environment.SaveSuccess) {
      message = environment.SaveNotSuccess;
    }
    
    this.config['panelClass'] = ['notification', 'warn'];
    this.snackBar.open(message, '', this.config);
    this.IsSave=true;
  }
  OpenWindowByURL(URLParamater, w = 100, h = 200) {
    var width = screen.width;
    var height = screen.height;
    var width01 = width - w;
    var height01 = height - h;
    var left = (width - width01) / 2;
    var top = (height - height01) / 3;
    var url = URLParamater;
    if (url) {
      // Replace domain with local APIRootURL
      var path = url;
      var domainMatch = url.match(/^https?:\/\/[^\/]+/);
      if (domainMatch) {
        path = url.substring(domainMatch[0].length).replace(/^\/+/, '');
      }
      url = environment.APIRootURL + path;
    }
    window.open(url, '_blank', 'location=yes,height=' + height01 + ',width=' + width01 + ',scrollbars=yes,status=yes,toolbar=yes,top=' + top + ',left=' + left + '');
  }
}
